<template>
  <v-app style="background-color: aliceblue;">
    <div id="app">
      <v-app-bar clipped-left fixed app style="height: 3.5rem; background-image: url('/bg.jpg'); background-repeat: repeat;">
        &nbsp;
        <v-menu bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" color="info">
              <v-icon large>mdi-menu</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item key="settings" @click="showSettings=true" align="left">
              <v-list-item-title>Настройки</v-list-item-title>
            </v-list-item>
            <v-list-item key="upload" @click="showUpload=true" align="left">
              <v-list-item-title>Выгрузить в ERP</v-list-item-title>
            </v-list-item>
            <v-list-item key="clearStorage" @click="showClearLocalStorage=true" align="left">
              <v-list-item-title>Очистить локальное хранилище</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        &nbsp;&nbsp;
        <v-toolbar-title class="text-h5 font-weight-medium text--secondary">Инвентаризация ver 2.2</v-toolbar-title>
        <v-spacer />
        <v-btn v-if="page!=='mainPage'" icon color="info" @click="page='mainPage'">
          <v-icon large>mdi-arrow-left-circle</v-icon>
        </v-btn>
        &nbsp;&nbsp;
      </v-app-bar>

      <v-container style="margin: 3.5rem auto 54px auto">

        <component :is="page" :param="param" @mainPage="page='mainPage'"
          @powerGridComplexList="page='powerGridComplexList'" 
          @powerGridComplexItem="powerGridComplexItem"
          @privateTransformerSubstationList="page='privateTransformerSubstationList'"
          @privateTransformerSubstationItem="privateTransformerSubstationItem" 
          @airLineList="page='airLineList'"
          @airLineItem="airLineItem" 
          @cableLineList="page='cableLineList'" 
          @cableLineItem="cableLineItem"
          @pillarList="page='pillarList'" 
          @pillarItem="pillarItem"
          @switchboardEquipmentList="page='switchboardEquipmentList'"
          @switchboardEquipmentItem="switchboardEquipmentItem" 
        />
      </v-container>

      <v-footer app height="50px" style="background-image: url('/bg.jpg'); background-repeat: repeat; border-top: solid; border-top-width: 2px; border-top-color: lightgray;">
        <v-spacer />
        <span class="text--secondary" style="margin-top: -3px; font-size: 12px;">
          <v-row cols="6" sm="6">
            <img src="../public/img/icons/android-chrome-192x192_transparent.png" alt="" style="height: 26px; margin-top: 4px;">
          </v-row>
        </span>
        <v-spacer />
      </v-footer>

      <confirm 
        v-if="showClearLocalStorage" 
        header="Удалить все данные?" 
        text="Будет очищено локальное хранилище"
        @ok="showClearLocalStorage = false; clearLocalStorage();" 
        @cancel="showClearLocalStorage = false" 
      />

      <upload 
        v-if="showUpload" 
        @close="reloadMainPage(); showUpload = false;" 
      />

      <settings 
        v-if="showSettings" 
        @ok="showSettings = false;" 
        @cancel="showSettings = false" 
      />

    </div>
  </v-app>
</template>

<script>
import common from "@/common";
import confirm from "@/components/common/confirm";

import mainPage from "@/components/mainPage";

import powerGridComplexList from "@/components/powerGridComplexList";
import powerGridComplexItem from "@/components/powerGridComplexItem";

import privateTransformerSubstationList from "@/components/privateTransformerSubstationList";
import privateTransformerSubstationItem from "@/components/privateTransformerSubstationItem";

import airLineItem from "@/components/airLineItem";
import airLineList from "@/components/airLineList";
import cableLineItem from "@/components/cableLineItem";
import cableLineList from "@/components/cableLineList";
import pillarItem from "@/components/pillarItem";
import pillarList from "@/components/pillarList";
import switchboardEquipmentItem from "@/components/switchboardEquipmentItem";
import switchboardEquipmentList from "@/components/switchboardEquipmentList";

import offlineMaps from "@/components/common/offlineMaps";

import upload from './components/common/upload.vue';
import settings from './components/common/settings.vue';
import OfflineMaps from './components/common/offlineMaps.vue';

export default {
  name: 'App',
  components: {
    switchboardEquipmentList,
    switchboardEquipmentItem,

    pillarList,
    pillarItem,

    cableLineList,
    cableLineItem,

    airLineList,
    airLineItem,

    privateTransformerSubstationItem,
    privateTransformerSubstationList,

    powerGridComplexList,
    powerGridComplexItem,

    offlineMaps,

    confirm,
    mainPage,

    upload,
    settings,
    OfflineMaps,
  },

  data() {
    return {
      page: "mainPage",
      param: "",
      showClearLocalStorage: false,
      showUpload: false,
      showSettings: false,
    }
  },

  methods: {

    powerGridComplexItem(id) {
      this.param = id
      this.page = 'powerGridComplexItem'
    },

    privateTransformerSubstationItem(id) {
      this.param = id
      this.page = 'privateTransformerSubstationItem'
    },

    airLineItem(id) {
      this.param = id
      this.page = 'airLineItem'
    },

    cableLineItem(id) {
      this.param = id
      this.page = 'cableLineItem'
    },

    pillarItem(id) {
      this.param = id
      this.page = 'pillarItem'
    },

    switchboardEquipmentItem(id) {
      this.param = id
      this.page = 'switchboardEquipmentItem'
    },

    clearLocalStorage() {
      common.clearLocalStorage()
      this.reloadMainPage()
    },

    reloadMainPage() {
      this.page = ''
      this.$nextTick(()=>{this.page = 'mainPage'})
    },
  },

}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  color: #2c3e50;
}
</style>
